import { defineMessages } from "../define";

export default defineMessages({
  en: {
    "slicing.tab": "Slicing",
    "slicing.title": "Slicing",
    "slicing.sliceCount": "Slices: {count}",
    "slicing.ok": "OK",
    "slicing.small": "Smaller than 1/{n} − tolerance",
    "slicing.target": "Target {target}% ± {tol}% (min. {min}%)",
    "slicing.targetShort": "target {target}%",
    "slicing.uncut": "Not sliced",
    "slicing.smallShort": "{count} small",
    "slicing.allOk": "all OK",
    "slicing.skipped": "Not evaluated",
    "slicing.noData": "Slicing could not be computed (photo or crust mask missing).",
    "slicing.loading": "Computing slicing…",
    "slicing.modeOverlay": "Cuts",
    "slicing.modeSource": "Photo",
    "slicing.loupeHint": "Magnifier under the cursor · scroll to zoom",
    "slicing.slice": "Slice {n}",
    "slicing.distribution": "Slice area (%)",
    "slicing.infoOnly": "Informational, not part of the verdict",
    "obstacle.tab": "Obstacles",
    "obstacle.title": "Obstacles over the pizza",
    "obstacle.class.hand": "Hand",
    "obstacle.class.paper": "Paper",
    "obstacle.class.lid": "Lid",
    "obstacle.class.cup": "Cup",
    "obstacle.covered": "Covered {value}%",
    "obstacle.limit": "limit {value}%",
    "obstacle.coverageTitle": "Covered share of the pizza",
    "obstacle.verdictCovered": "Invalid photo: something covers the pizza",
    "obstacle.verdictGap": "Invalid photo: part of the crust is missing",
    "obstacle.verdictBelow": "Obstacle below the limit",
    "obstacle.verdictClear": "Nothing covers the pizza",
    "obstacle.outside": "beside the pizza",
    "obstacle.confidence": "confidence {value}%",
    "obstacle.ofPizza": "{value}% of the pizza",
    "obstacle.gap": "Gap in the crust",
    "obstacle.gapLabel": "Crust missing · {value}%",
    "obstacle.gapValue": "{value}% of the rim",
    "obstacle.nothingFound": "The model found no obstacle",
    "obstacle.preview": "Preview computed now from the stored photo; the stored evaluation is unchanged.",
    "obstacle.shadow": "Shadow mode: the model does not decide yet.",
    "obstacle.skipped": "The model did not run ({reason})",
    "obstacle.skippedShort": "The model did not run",
    "obstacle.loading": "Looking for obstacles…",
    "obstacle.noData": "Obstacles could not be computed (photo or crust mask missing).",
    "obstacle.modeMask": "Mask",
    "obstacle.modeSource": "Photo",
    "obstacle.model": "model {version}",
    "obstacle.labelCovers": "{name} · {value}%",
  },
  cs: {
    "slicing.tab": "Krájení",
    "slicing.title": "Krájení",
    "slicing.sliceCount": "Kousků: {count}",
    "slicing.ok": "V pořádku",
    "slicing.small": "Menší než 1/{n} − tolerance",
    "slicing.target": "Cíl {target} % ± {tol} % (min. {min} %)",
    "slicing.targetShort": "cíl {target} %",
    "slicing.uncut": "Nenakrájená",
    "slicing.smallShort": "{count}× menší",
    "slicing.allOk": "vše OK",
    "slicing.skipped": "Nevyhodnoceno",
    "slicing.noData": "Krájení se nepodařilo spočítat (chybí fotka nebo maska okraje).",
    "slicing.loading": "Počítám krájení…",
    "slicing.modeOverlay": "Řezy",
    "slicing.modeSource": "Fotka",
    "slicing.loupeHint": "Lupa pod kurzorem · kolečkem myši přiblížíte",
    "slicing.slice": "Kousek {n}",
    "slicing.distribution": "Plocha kousků (%)",
    "slicing.infoOnly": "Informativní, nepočítá se do verdiktu",
    "obstacle.tab": "Překážky",
    "obstacle.title": "Překážky na pizze",
    "obstacle.class.hand": "Ruka",
    "obstacle.class.paper": "Papír",
    "obstacle.class.lid": "Víko",
    "obstacle.class.cup": "Kelímek",
    "obstacle.covered": "Zakryto {value} %",
    "obstacle.limit": "limit {value} %",
    "obstacle.coverageTitle": "Zakrytá část pizzy",
    "obstacle.verdictCovered": "Neplatná fotka: pizzu něco zakrývá",
    "obstacle.verdictGap": "Neplatná fotka: chybí část okraje",
    "obstacle.verdictBelow": "Překážka pod limitem",
    "obstacle.verdictClear": "Pizzu nic nezakrývá",
    "obstacle.outside": "mimo pizzu",
    "obstacle.confidence": "jistota {value} %",
    "obstacle.ofPizza": "{value} % pizzy",
    "obstacle.gap": "Mezera v okraji",
    "obstacle.gapLabel": "Chybí okraj · {value} %",
    "obstacle.gapValue": "{value} % obvodu",
    "obstacle.nothingFound": "Model nenašel žádnou překážku",
    "obstacle.preview": "Náhled spočítaný teď z uložené fotky; uložené vyhodnocení se nemění.",
    "obstacle.shadow": "Stínový režim: model zatím nerozhoduje.",
    "obstacle.skipped": "Model neběžel ({reason})",
    "obstacle.skippedShort": "Model neběžel",
    "obstacle.loading": "Hledám překážky…",
    "obstacle.noData": "Překážky se nepodařilo spočítat (chybí fotka nebo maska okraje).",
    "obstacle.modeMask": "Maska",
    "obstacle.modeSource": "Fotka",
    "obstacle.model": "model {version}",
    "obstacle.labelCovers": "{name} · {value} %",
  },
});
